/**
 * Gráfica de "Estado actual" de las órdenes (presentacional).
 *
 * Réplica de la dona "Estado actual" del SSR (`advanced_stats_with_charts.html`,
 * `createStatusChart`): cuenta las órdenes por estado (pendientes/completadas/
 * entregadas/anuladas) a partir del detalle de timing y las presenta como barras
 * (la SPA no usa Chart.js; ver `BarChart`). Recibe la query de timing ya en marcha;
 * el `ChartCard` contempla los estados de carga/error.
 */
import { statusCounts } from "../format";
import type { OrdersTimingStats } from "../types";
import { BarChart } from "./BarChart";
import { ChartCard } from "./ChartCard";

interface StatusChartProps {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  data: OrdersTimingStats | undefined;
}

export function StatusChart({ isPending, isError, error, data }: StatusChartProps) {
  return (
    <ChartCard<OrdersTimingStats>
      title="Estado actual"
      isPending={isPending}
      isError={isError}
      error={error}
      data={data}
    >
      {(timing) => {
        const counts = statusCounts(timing.timing_data);
        return (
          <BarChart
            barClassName="bg-violet-500"
            data={[
              { label: "Pendientes", value: counts.pending },
              { label: "Completadas", value: counts.completed },
              { label: "Entregadas", value: counts.delivered },
              { label: "Anuladas", value: counts.cancelled },
            ]}
            emptyMessage="Sin órdenes registradas."
          />
        );
      }}
    </ChartCard>
  );
}
